import { render, staticRenderFns } from "./DSPopUp.vue?vue&type=template&id=61a542c6&scoped=true&"
import script from "./DSPopUp.vue?vue&type=script&lang=ts&"
export * from "./DSPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./DSPopUp.vue?vue&type=style&index=0&id=61a542c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a542c6",
  null
  
)

export default component.exports